function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/prop-types */
import { debounce } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import React, { cloneElement, createRef, isValidElement } from 'react';
import ClickAway from '../ClickAway';
import FocusTrap from '../FocusTrap';
import OpenableComponent from '../OpenableComponent';
import OverlayHeader from '../OverlayHeader';
import classNames from '../utils/classNames';
var ONE_FRAME_MS = 17;
/**
 * The Overlay component is a modal layered UI. It is used to present
 * additional more detailed information over the main page. It is designed
 * to work with @sie/web-common-layers and the UiLayers component.
 *
 * - [Design Spec](https://atlas.np.tools.playstation.net/design/7ca5464e-1b6b-48f4-81fa-36c7a00d69cf/2?bounds=-0.183,0.151,0.964,0.655)
 * - [Web Common Layers](https://github.sie.sony.com/pages/SIE/web-common-toolkit/core/layers/)
 * - [UiLayers](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/UiLayers)
 *
 * ## Usage
 *
 * ```jsx
 * <Overlay title="My Overlay">
 *   <p>Some overlay contents</p>
 * </Overlay>
 * ```
 *
 * Custom header width
 *
 * ```jsx
 * <Overlay
 *  header={(
 *    <OverlayHeader className="psw-l-w-1/2">
 *      My Overlay
 *    </OverlayHeader>
 *  )}
 * >
 *   <p>Some overlay contents</p>
 * </Overlay>
 * ```
 *
 * With footer
 *
 * ```jsx
 * <Overlay
 *  header={(
 *    <OverlayHeader>
 *      My Overlay
 *    </OverlayHeader>
 *  )}
 *  footer={(
 *    <OverlayFooter>
 *      <Button ctaType="tertiary">Learn More, I am a lot longer</Button>
 *      <Button ctaType="primary">I Got it!</Button>
 *    </OverlayFooter>
 *  )}
 * >
 *   <p>Some overlay contents</p>
 * </Overlay>
 * ```
 */

var Overlay = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(Overlay, _OpenableComponent);

  var _super = _createSuper(Overlay);

  function Overlay(props) {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickAway", function (event) {
      event.stopPropagation();

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "_onScroll", debounce(function () {
      var contentScrollPosition = _this._body.current.scrollTop;

      if (contentScrollPosition > 5) {
        _this._root.current.classList.add('psw-is-scrolled');
      } else {
        _this._root.current.classList.remove('psw-is-scrolled');
      }
    }, ONE_FRAME_MS));

    _defineProperty(_assertThisInitialized(_this), "_onResize", debounce(function () {
      return _this._evaluateContentDensity();
    }, ONE_FRAME_MS));

    _this._root = /*#__PURE__*/createRef();
    _this._content = /*#__PURE__*/createRef();
    _this._body = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var openOnMount = this.props.openOnMount;
      window.addEventListener('resize', this._onResize);

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this2.open();
        });
      }

      setTimeout(function () {
        return _this2._evaluateContentDensity();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._onResize);
    }
  }, {
    key: "_renderHeader",
    value: function _renderHeader() {
      var _this$props = this.props,
          closeLabel = _this$props.closeLabel,
          qa = _this$props.qa,
          header = _this$props.header,
          title = _this$props.title,
          titleId = _this$props.titleId;

      if (header && /*#__PURE__*/isValidElement(header)) {
        return /*#__PURE__*/cloneElement(header, {
          id: titleId,
          qa: "".concat(qa, "#header"),
          onClose: this.close
        });
      }

      return /*#__PURE__*/React.createElement(OverlayHeader, {
        id: titleId,
        closeLabel: closeLabel,
        qa: "".concat(qa, "#header"),
        onClose: this.close
      }, title);
    }
  }, {
    key: "_renderFooter",
    value: function _renderFooter() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          variant = _this$props2.variant,
          footer = _this$props2.footer;
      var resolvedFooter = typeof footer === 'function' ? footer({
        close: this.close
      }) : footer;
      if (! /*#__PURE__*/isValidElement(resolvedFooter)) return null;
      return /*#__PURE__*/cloneElement(resolvedFooter, {
        className: variant === 'fixed' ? 'psw-l-bottom-left psw-l-anchor-bottom-left' : 'psw-l-pin-b',
        qa: "".concat(qa, "#footer")
      });
    }
  }, {
    key: "_evaluateContentDensity",
    value: function _evaluateContentDensity() {
      var variant = this.props.variant;
      var overlayContent = variant === 'fixed' ? this._root.current : this._body.current;
      var rootEl = this._root.current;
      if (!overlayContent) return;

      if (rootEl && overlayContent.clientHeight < overlayContent.scrollHeight) {
        rootEl.classList.add('psw-is-high-density');
      } else {
        rootEl.classList.remove('psw-is-high-density');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          titleId = _this$props3.titleId,
          className = _this$props3.className,
          qa = _this$props3.qa,
          children = _this$props3.children,
          disableClickAway = _this$props3.disableClickAway,
          variant = _this$props3.variant,
          includeWrapper = _this$props3.includeWrapper;
      var isOpen = this.isOpen();
      if (!isOpen) return null;

      this._evaluateContentDensity();

      var footer = this._renderFooter();

      var isFixed = variant === 'fixed';
      var isNonFullScreenScrollable = variant === 'nonFullScreenScrollable';
      var isScrollable = variant === 'scrollable' || isNonFullScreenScrollable;
      return /*#__PURE__*/React.createElement("div", {
        ref: this._root,
        "data-qa": qa,
        className: classNames(isFixed ? "psw-overlay-".concat(variant) : 'psw-overlay', 'psw-c-bg-0', isNonFullScreenScrollable ? 'psw-l-non-full-screen' : 'psw-l-full-screen', {
          'psw-pointer-events-on': isOpen
        }, {
          'psw-with-footer': !!footer
        }, {
          'psw-scroll-y': isFixed
        }, className)
      }, /*#__PURE__*/React.createElement(ClickAway, {
        node: this._content,
        onClickAway: this.onClickAway,
        disabled: disableClickAway
      }, /*#__PURE__*/React.createElement(FocusTrap, {
        className: classNames({
          'psw-fill': isScrollable
        }),
        node: this._content,
        onEscape: this.close,
        trap: this.isOpen(),
        allowArrowKeys: false,
        includeWrapper: includeWrapper
      }, /*#__PURE__*/React.createElement("section", {
        ref: this._content,
        role: "dialog",
        "aria-labelledby": titleId,
        "aria-modal": "true",
        onScrollCapture: isScrollable ? this._onScroll : null,
        className: classNames('psw-overlay-content', {
          'psw-fill-x': isScrollable
        }, _defineProperty({}, classNames('psw-c-bg-card-2', 'psw-p-x-8', 'psw-m-sub-x-8', 'psw-r-4', 'psw-l-w-full-bleed', 'psw-l-w-1/2@tablet-s', 'psw-l-w-1/2@tablet-l', 'psw-l-w-1/3@laptop', 'psw-l-w-1/3@desktop', 'psw-l-w-1/3@max', !footer && 'psw-p-b-8'), isFixed))
      }, this._renderHeader(), /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#body"),
        ref: this._body,
        className: classNames('psw-overlay-body', isScrollable && 'psw-p-y-5')
      }, children), footer && /*#__PURE__*/cloneElement(footer, {
        className: null,
        spacer: true
      }), footer && /*#__PURE__*/cloneElement(footer, {
        variant: variant === 'fixed' ? 'transparent' : 'standard'
      })))));
    }
  }]);

  return Overlay;
}(OpenableComponent);

Overlay.defaultProps = {
  qa: '',
  className: '',
  closeLabel: '',
  variant: 'scrollable',
  title: '',
  titleId: '',
  header: null,
  footer: null,
  children: null,
  disableClickAway: true,
  openOnMount: false,
  isOpen: null,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  includeWrapper: false
};
Overlay.propTypes = {
  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * Add custom classes to the Overlay
   */
  className: PropTypes.string,

  /**
   * Value to use for close button aria-label
   */
  closeLabel: PropTypes.string,

  /**
   * The presentational variant of the overlay
   */
  variant: PropTypes.oneOf(['scrollable', 'fixed', 'nonFullScreenScrollable']),

  /**
   * The title of the overlay, if a header is provided it will take precedence over
   * the title
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Unique id to allow associating the overlay with header title content via
   * aria-describedby or aria-labelledby.
   */
  titleId: PropTypes.string,

  /**
   * Overlay header to display a title for the overlay
   */
  header: PropTypes.node,

  /**
   * Overlay content
   */
  children: PropTypes.node,

  /**
   * Optional footer content for overlay call to actions
   */
  footer: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * Whether to disable the click away behavior of the overlay
   */
  disableClickAway: PropTypes.bool,

  /**
   * Whether or not to open the Overlay when it is mounted. This prop will only take
   * effect if the Overlay is not controlled
   */
  openOnMount: PropTypes.bool,

  /**
   * If set to null the state will be managed internally. If a boolean is passed
   * the overlay will be controlled
   */
  isOpen: PropTypes.bool,

  /**
   * Event callback called when the Overlay is opened
   */
  onOpen: PropTypes.func,

  /**
   * Event callback called when the Overlay is closed
   */
  onClose: PropTypes.func,

  /**
   * This prop tell FocusWrap component whether to include a wrapping component or not.
   * A wrapping component is necessary when forwarding a ref. This prop was added to
   * disambiguate the default behavior which was to prefer not including a wrapping element in
   * favor of a previously established node.
   */
  includeWrapper: PropTypes.bool
};
export default Overlay;